import { render, staticRenderFns } from "./ProgramsUpdate.vue?vue&type=template&id=d00fc8a2&scoped=true"
import script from "./ProgramsUpdate.vue?vue&type=script&lang=js"
export * from "./ProgramsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00fc8a2",
  null
  
)

export default component.exports